import { useState, useEffect } from 'react';
import './EditableInput.scss';

type EditableInputProps = {
  title: string;
  index?: number;
  initialValue?: string | number;
  price?: number;
  editable?: boolean;
  onValueChange?: (title: string, initialValue?: string | number, index?: number) => void;
  selectOptions?: string[];
};

const EditableInput = ({
  title,
  index,
  initialValue,
  onValueChange,
  editable = true,
  selectOptions,
}: EditableInputProps) => {
  const [value, setValue] = useState(initialValue);
  const [editing, setEditing] = useState(false);
  const isEmpty = value === '0.00' || '' || '0';
  const isNadaOrInvoice = title.includes('NADA') || title.includes('Invoice');
  const buttonText = editing ? 'save' : isEmpty && isNadaOrInvoice ? 'add' : 'edit';

  useEffect(() => {
    onValueChange && onValueChange(title, value, index);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, value, index]);

  return (
    <div className="editableInput-outer">
      {!editing ? (
        <p>{value}</p>
      ) : selectOptions ? (
        <select
          value={value}
          onChange={e => {
            setValue(e.target.value);
          }}>
          {selectOptions.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
        </select>
      ) : (
        <input
          value={value}
          onChange={e => {
            setValue(e.target.value);
          }}
        />
      )}
      {editable && (
        <button className="editable-button" onClick={() => setEditing(!editing)}>
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default EditableInput;
